import { getMaster } from "utils/api";

export const fetchDataDashboard = async (type) => {
  return await getMaster(`/data/dashboard?type=${type}`);
};
